import React, {Component,PureComponent} from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form'
import {Row, Form, Button, Icon, Input, Divider, Tooltip, Popconfirm} from 'antd';
import {RTLCol, RTLButton, RTLModal, RTLTable} from '../RTLKit';

/* ------ Field -------- */
import TextArea from '../formFields/TextAreaField';
import DescriptionList from '../formFields/DescriptionList';


/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';
import Loading from "../loading/loading";

class CancelForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            orderId: this.props.match.params.orderId ? this.props.match.params.orderId : null,
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            formLayout: 'horizontal',
        };
        this.props.setOrderId(this.state.orderId);

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentDidMount() {
        if (this.props.match.params.orderId){
            let id = this.props.match.params.orderId;
            this.props.getItem(id)
        }
    }

    render() {
        var _self = this;
        const {formLayout} = this.state;

        /*---- set mode ---*/
        let orderType = '';
        let orderDescription = [];
        let schedule_time;
        let hour = 1;
        let minute = 0;
        let year = 0;
        let month = 0;
        let day = 0;
        let technician_by;
        if(this.props.initialValues) {
            orderType = (this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY' ? 'خرید دستگاه' : 'تعمیرات');
            if(this.props.initialValues.order.order_type === 'ORDER_TYPE_BUY') {
                if(this.props.initialValues.order.product)
                    orderDescription = 'درخواست خرید محصول: ' + this.props.initialValues.order.product.description;
            }else{
                orderDescription = 'درخواست تعمیرات شامل:'
                if(this.props.initialValues.order.fixtures)
                    for(let i=0 ; i<this.props.initialValues.order.fixtures.length ; i++){
                        orderDescription += this.props.initialValues.order.fixtures[i].title+' - ';
                    }
            }

            this.props.initialValues.mode=this.state.mode
        }

        return (
            <Form layout={formLayout} mode={this.state.mode} onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                <Row>
                    <Divider orientation="left">لغو درخواست</Divider>
                </Row>
                {this.state.mode == 'edit' ?
                    <Loading list={this.props.initialValues} />
                    : null}
                <Row type="flex" justify="start" align="middle">
                    <RTLCol md={18} sm={24} type="flex" justify="start" align="middle" >
                        <Row gutter={16}>

                            <DescriptionList label="نوع درخواست" description={orderType} />

                            <DescriptionList label="شرح خدمات" description={orderDescription} />

                            <Field
                                name="cancel_description"
                                component={TextArea}
                                type='textArea'
                                rows={4}
                                label="دلیل لغو"
                                placeholder="دلیل لغو"
                            />

                        </Row>
                        <Row>
                            <RTLButton loading={this.props.common.isProgressing} type="primary"  shape="round" htmlType="submit" className="login-form-button">
                                {this.state.mode == 'edit' ? "ویرایش" : "ایجاد"}
                            </RTLButton>
                            <RTLButton href="#/order/list" className="backBtn" type="default" shape="round">
                                بازگشت
                            </RTLButton>
                        </Row>
                    </RTLCol>
                </Row>
            </Form>

        );
    }

}

export default CancelForm = reduxForm({
    form: 'order',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(CancelForm)
